/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * This helper is a slight modification of
 * the official DatoCMS isEmptyDocument() function, found here:
 * https://github.com/datocms/structured-text/blob/main/packages/utils/src/guards.ts#L115C1-L143C2
 *
 * The difference is this helper applies v() to the final value in the return,
 * so that zero-width spaces used in Vercel Visual Editing can be stripped out
 * before comparison.
 *
 * Modified from an example provided by Dylan here (thanks!):
 * https://github.com/hashicorp/web/pull/1378#issuecomment-2050416755
 */

import {
	isStructuredText,
	isDocument,
	StructuredText,
	Document,
} from 'datocms-structured-text-utils'
import { vercelSplit } from '@web/cms'

export function isEmptyDocumentV(
	obj: StructuredText | Document | undefined | null,
): boolean {
	if (!obj) {
		return true
	}

	let document = null

	if (isStructuredText(obj)) {
		document = obj.value
	} else if (isDocument(obj)) {
		document = obj
	}

	if (!document) {
		throw new Error(
			'Passed object is neither null, a Structured Text value or a DAST document',
		)
	}

	return (
		document.schema === 'dast' &&
		document.document.children.length === 1 &&
		document.document.children[0].type === 'paragraph' &&
		document.document.children[0].children.length === 1 &&
		document.document.children[0].children[0].type === 'span' &&
		vercelSplit(document.document.children[0].children[0].value) === ''
	)
}
